module.exports = __webpack_public_path__ + "img/ai.7ae69566.svg";